module.exports = __webpack_public_path__ + "media/images/panel-e5258930159e57b1b24ab9723bb50b17.svg";